module.exports = __webpack_public_path__ + "static/media/b_qx_sport.733e0471.glb";